import React from 'react';
import { isIos } from '../../../common/utils/ios-utils';
const isVisualViewportSupported = (window) => typeof window !== 'undefined' && typeof window.visualViewport !== 'undefined';
class ViewportIosContainer extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = { height: '100%' };
        this.handleViewportResize = () => {
            if (this.props.enabled) {
                if (this.props.preventScroll && window.scrollY !== 0) {
                    window.scrollBy(0, window.scrollY * -1);
                    // compensate for ios autoscroll on input focus
                }
                this.setState((s) => ({
                    height: window.visualViewport ? Math.round(window.visualViewport.height) : s,
                }));
            }
        };
    }
    componentDidMount() {
        if (isIos() && isVisualViewportSupported(window)) {
            this.setState({ height: Math.round(window.visualViewport.height) });
            window.visualViewport.addEventListener('resize', this.handleViewportResize);
            window.visualViewport.addEventListener('scroll', this.handleViewportResize);
        }
    }
    componentWillUnmount() {
        if (isIos() && isVisualViewportSupported(window)) {
            window.visualViewport.removeEventListener('resize', this.handleViewportResize);
            window.visualViewport.removeEventListener('scroll', this.handleViewportResize);
        }
    }
    render() {
        const { children, dataHook, className } = this.props;
        return (React.createElement("div", { className: className, "data-hook": dataHook, style: { height: this.state.height } }, children));
    }
}
ViewportIosContainer.defaultProps = {
    preventScroll: true,
    enabled: true,
};
export default ViewportIosContainer;
//# sourceMappingURL=ios-viewport-container.js.map